import styled from 'styled-components';

export const Root = styled.div`
  & > * {
    margin-right: 0.25rem;
  }
`;
